document.addEventListener('click', (event) => {
  const openButton = event.target.closest('.worth-return-open');
  if (openButton) {
    const root = openButton.closest('.worth-return-block');
    const form = root?.querySelector('.worth-return-form');
    if (!form) return;

    openButton.hidden = true;
    openButton.setAttribute('aria-expanded', 'true');
    form.hidden = false;
    form.querySelector('input')?.focus();
    return;
  }

  const closeButton = event.target.closest('.worth-return-modal-close, .worth-return-modal-dismiss');
  const dialog = closeButton?.closest('.worth-return-modal');
  if (dialog) dialog.close();
});

document.addEventListener('click', (event) => {
  if (event.target.matches('.worth-return-modal')) event.target.close();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;

  const dialog = document.querySelector('.worth-return-modal[open]');
  if (dialog) {
    event.preventDefault();
    dialog.close();
  }
});

document.addEventListener('cancel', (event) => {
  if (!event.target.matches('.worth-return-modal')) return;
  event.preventDefault();
  event.target.close();
}, true);

document.addEventListener('close', (event) => {
  if (!event.target.matches('.worth-return-modal')) return;
  event.target.closest('.worth-return-block')?.querySelector('.worth-return-form input')?.focus();
}, true);

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.worth-return-form');
  if (!form) return;

  event.preventDefault();
  const input = form.querySelector('input');
  const error = form.querySelector('.worth-return-error');
  const submitButton = form.querySelector('button[type="submit"]');
  const root = form.closest('.worth-return-block');
  const dialog = root?.querySelector('.worth-return-modal');
  const barcode = input.value.trim();
  const isValid = /^\d{6,32}$/.test(barcode);

  error.hidden = isValid;
  input.setAttribute('aria-invalid', isValid ? 'false' : 'true');
  if (!isValid) {
    input.focus();
    return;
  }

  const loading = dialog.querySelector('.worth-return-loading');
  const announcement = dialog.querySelector('.worth-return-announcement');
  const result = dialog.querySelector('.worth-return-result');
  const product = dialog.querySelector('.worth-return-product');
  const validity = dialog.querySelector('.worth-return-validity');

  loading.hidden = false;
  result.hidden = true;
  product.hidden = true;
  submitButton.disabled = true;
  dialog.showModal();
  announcement.textContent = loading.textContent.trim();

  try {
    const response = await fetch(root.dataset.barcodeEndpoint, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ barcode }),
    });
    const data = await response.json();

    if (!response.ok) {
      throw new Error(response.status === 429 ? root.dataset.rateLimited : root.dataset.checkFailed);
    }
    if (!data.success || !data.item) {
      const message = root.dataset.notFound;
      result.textContent = message;
      announcement.textContent = message;
      result.hidden = false;
      return;
    }

    // API data is assigned as text only, preventing imported content from becoming executable markup.
    dialog.querySelectorAll('[data-barcode-field]').forEach((field) => {
      field.textContent = data.item[field.dataset.barcodeField] || '–';
    });
    dialog.querySelector('[data-valid-to]').hidden = Boolean(data.item.valid);
    validity.textContent = data.item.note || (data.item.valid ? root.dataset.valid : root.dataset.invalid);
    validity.classList.toggle('is-valid', Boolean(data.item.valid));
    validity.classList.toggle('is-invalid', !data.item.valid);
    product.hidden = false;
    announcement.textContent = `${root.dataset.found} ${data.item.description || barcode}. ${validity.textContent}`;
  } catch (requestError) {
    const message = requestError.message || root.dataset.checkFailed;
    result.textContent = message;
    announcement.textContent = message;
    result.hidden = false;
  } finally {
    loading.hidden = true;
    submitButton.disabled = false;
  }
});